// src/components/Payment/UpiPayment.js
import React, { useEffect, useState } from 'react';
import QRCode from 'qrcode';
import { useLang } from '../../i18n/LanguageContext';
import { UPI_ID, UPI_NAME } from '../../data/contact';
import { upiUri } from '../../utils/upi';

// The QR is drawn from the UPI ID below, so the code and the text can never disagree.
const UpiPayment = () => {
  const { t } = useLang();
  const [qr, setQr] = useState(null);
  const [copied, setCopied] = useState(false);
  const link = upiUri(UPI_ID, UPI_NAME);

  useEffect(() => {
    let alive = true;
    QRCode.toDataURL(link, { width: 480, margin: 1, errorCorrectionLevel: 'M', color: { dark: '#0F1B3D', light: '#FFFFFF' } })
      .then((url) => { if (alive) setQr(url); })
      .catch(() => { if (alive) setQr(null); });
    return () => { alive = false; };
  }, [link]);

  const copy = () => {
    const done = () => { setCopied(true); setTimeout(() => setCopied(false), 2000); };
    if (navigator.clipboard) navigator.clipboard.writeText(UPI_ID).then(done, () => {});
  };

  return (
    <div className="text-center">
      <div className="mx-auto w-56 h-56 sm:w-64 sm:h-64 rounded-2xl border-4 border-brand p-2 bg-white flex items-center justify-center">
        {qr ? <img src={qr} alt={`UPI QR code for ${UPI_ID}`} className="w-full h-full" /> : <span className="text-sm text-slate-400">QR…</span>}
      </div>
      <p className="mt-4 text-sm text-slate-500">{t('upiOr')}</p>
      <div className="mt-2 inline-flex items-center gap-2 bg-sky rounded-xl pl-4 pr-1.5 py-1.5 max-w-full">
        <strong className="text-brand tracking-wide break-all">{UPI_ID}</strong>
        <button type="button" onClick={copy} className="shrink-0 text-xs font-bold bg-white text-ink rounded-lg px-3 py-2 shadow-sm">{copied ? t('copied') : t('copy')}</button>
      </div>
      <a href={link} className="md:hidden mt-4 block bg-brand text-white font-bold py-3 rounded-xl">{t('openUpi')}</a>
    </div>
  );
};

export default UpiPayment;
